import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { of, timer } from 'rxjs';
import { map, filter, tap } from 'rxjs/operators';
import * as _moment from 'moment';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function CountdownComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.formattedTime$), "\n");
} }
function CountdownComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.completeText, " ");
} }
const moment = _moment;
class CountdownComponent {
    constructor() {
        /** The time that the end date was requested - used to return time remaining more accurately than using moment.utc */
        this.requestDateTime = '';
        /** The text to display in the countdown upon expiry. */
        this.completeText = 'Complete';
        /** determines whether component will receive local or utc time. default is utc. */
        this.isUTC = true;
        /** Emitted upon countdown expiry. */
        this.complete = new EventEmitter();
        this.completed = false;
    }
    ngOnInit() {
        this.setTimer(this.endDateTime);
    }
    ngOnChanges(changes) {
        if (changes.endDateTime) {
            this.setTimer(changes.endDateTime.currentValue);
        }
    }
    /**
     * Sets the countdown timer relative to the supplied endDateTime.
     * @param endDateTime The time that the countdown should end as a UTC date.
     */
    setTimer(endDateTime) {
        this.endDate = this.isUTC ? moment.utc(endDateTime) : moment.utc(new Date(endDateTime).toUTCString());
        this.setRequestDate();
        if (this.endDate < this.requestDate) {
            this.completed = true;
            this.complete.emit(this.completed);
            this.formattedTime$ = of(this.completeText);
        }
        else {
            this.completed = false;
            this.formattedTime$ = timer(0, 1000).pipe(
            // convert interval into remaining time in seconds
            map(() => {
                this.setRequestDate();
                let utcNow = this.requestDate;
                return Math.floor(this.endDate.diff(utcNow, 'seconds'));
            }), 
            // stop emission after complete
            filter(() => !this.completed), 
            // emit on complete
            tap((t) => {
                if (t <= 0) {
                    this.completed = true;
                    this.complete.emit(this.completed);
                }
            }), map(this.formatRemainingTime));
        }
    }
    setRequestDate() {
        this.requestDate = this.requestDateTime.length > 0 ? moment(this.requestDateTime) : moment.utc();
        this.requestDate = this.isUTC ? moment.utc(this.requestDate) : moment.utc();
    }
    formatRemainingTime(seconds) {
        const days = Math.floor(seconds / 86400);
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor(seconds / 60);
        if (days) {
            const remainderHours = Math.floor((seconds % 86400) / 3600);
            return `${days}d ${remainderHours}h`;
        }
        else if (hours) {
            const remainderMinutes = Math.floor((seconds % 3600) / 60);
            return `${hours}h ${remainderMinutes}m`;
        }
        else if (minutes) {
            const remainderSeconds = seconds % 60;
            return `${minutes}m ${remainderSeconds}s`;
        }
        else {
            return `${seconds}s`;
        }
    }
}
CountdownComponent.ɵfac = function CountdownComponent_Factory(t) { return new (t || CountdownComponent)(); };
CountdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CountdownComponent, selectors: [["fgbcl-countdown"]], inputs: { requestDateTime: "requestDateTime", completeText: "completeText", isUTC: "isUTC", endDateTime: "endDateTime" }, outputs: { complete: "complete" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [["class", "countdown-timer font-weight-bold", 4, "ngIf", "ngIfElse"], ["showComplete", ""], [1, "countdown-timer", "font-weight-bold"]], template: function CountdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CountdownComponent_span_0_Template, 3, 3, "span", 0);
        ɵngcc0.ɵɵtemplate(1, CountdownComponent_ng_template_1_Template, 2, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.completed)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc1.AsyncPipe], styles: [""] });
CountdownComponent.ctorParameters = () => [];
CountdownComponent.propDecorators = {
    endDateTime: [{ type: Input }],
    requestDateTime: [{ type: Input }],
    completeText: [{ type: Input }],
    isUTC: [{ type: Input }],
    complete: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CountdownComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-countdown',
                template: "<span *ngIf=\"!completed; else showComplete\" class=\"countdown-timer font-weight-bold\">\r\n  {{ formattedTime$ | async }}\r\n</span>\r\n<ng-template #showComplete>\r\n  <span>\r\n    {{ completeText }}\r\n  </span>\r\n</ng-template>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { requestDateTime: [{
            type: Input
        }], completeText: [{
            type: Input
        }], isUTC: [{
            type: Input
        }], complete: [{
            type: Output
        }], endDateTime: [{
            type: Input
        }] }); })();

class CountdownModule {
}
CountdownModule.ɵfac = function CountdownModule_Factory(t) { return new (t || CountdownModule)(); };
CountdownModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CountdownModule });
CountdownModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CountdownModule, { declarations: function () { return [CountdownComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CountdownComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CountdownModule, [{
        type: NgModule,
        args: [{
                declarations: [CountdownComponent],
                imports: [CommonModule],
                exports: [CountdownComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CountdownComponent, CountdownModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-countdown.js.map